import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import { useThemeSettings } from '../ThemeProvider';
import { CONTENT_TYPES } from '../shared/constants/content-types';

interface BulletsContentProps {
  heading?: string;
  description?: string;
  content: string[];
  style?: object;
}

export const BulletsContent: React.FC<BulletsContentProps> = ({ heading, description, content, style = {} }) => {
  const { theme } = useThemeSettings();

  return (
    <View style={[styles.container, style]}>
      {heading && (
        <Text variant="headlineMedium" style={[styles.heading, { color: theme?.colors?.headerText }]}>
          {heading}
        </Text>
      )}
      {description && (
        <Text variant="bodyMedium" style={[styles.description, { color: theme?.colors?.bodyText }]}>
          {description}
        </Text>
      )}
      <View style={styles.bulletsList}>
        {content.map((item, index) => (
          <View key={index} style={styles.bulletItem}>
            <View style={[styles.bullet, { backgroundColor: theme?.colors?.bodyText }]} />
            <Text variant="bodyMedium" style={{ color: theme?.colors?.bodyText }}>
              {item}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  heading: {
    marginBottom: 8,
  },
  description: {
    marginBottom: 16,
  },
  bulletsList: {
    gap: 8,
  },
  bulletItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginTop: 6,
  },
});
